import { combineReducers } from "redux";

import commentsReducer from "./comments/comments";
import documentPreviewReducer from "./documentPreview/documentPreview";
import documentQueriesReducer from "./documentQueries/documentQueries";
import documentSearchReducer from "./documentSearch/documentSearch";
import linkDocumentReducer from "./linkDocument/linkDocument";
import publishReducer from "./publish/publish";

export default combineReducers({
  comments: commentsReducer,
  publish: publishReducer,
  documentPreview: documentPreviewReducer,
  documentQueries: documentQueriesReducer,
  documentSearch: documentSearchReducer,
  linkDocument: linkDocumentReducer
});
